// @ts-nocheck
import {createContext,useContext} from "react";

export const UsuarioContext = createContext({});
export function useUsuarios() {
    return useContext(UsuarioContext);
}
